(() => {
  'use strict';
  const config = JSON.parse(document.querySelector('#VeeramConfig')?.textContent || '{}');
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  let toastTimer;
  function proceedToCheckout() {
    const checkoutForm = document.createElement('form');
    checkoutForm.method = 'post';
    checkoutForm.action = config.cartUrl;
    checkoutForm.hidden = true;
    const checkoutButton = document.createElement('button');
    checkoutButton.type = 'submit';
    checkoutButton.name = 'checkout';
    checkoutButton.value = 'checkout';
    checkoutForm.append(checkoutButton);
    document.body.append(checkoutForm);
    checkoutForm.requestSubmit(checkoutButton);
  }
  async function addToCart(form, message, shopNow) {
    const response = await fetch(config.cartAdd, {method:'POST',body:new FormData(form),headers:{Accept:'application/json'}});
    const result = await response.json();
    if (!response.ok) throw new Error(typeof result.description === 'string' ? result.description : config.error);
    if (shopNow) { proceedToCheckout(); return; }
    if (message) message.textContent = config.added;
    const toast = document.querySelector('[data-cart-toast]');
    if (toast) {
      toast.querySelector('[data-cart-message]').textContent = config.added;
      toast.hidden = false;
      clearTimeout(toastTimer);
      toastTimer = setTimeout(() => { toast.hidden = true; }, 8000);
    }
    try {
      const cartResponse = await fetch(config.cart,{headers:{Accept:'application/json'}});
      if (cartResponse.ok) { const cart = await cartResponse.json(); document.querySelectorAll('[data-cart-count]').forEach(el => { el.textContent = cart.item_count; }); }
    } catch (_) { /* The successful addition is preserved if badge refresh fails. */ }
  }
  function initCardPurchase(form) {
    if (form.dataset.initialized) return;
    form.dataset.initialized = 'true';
    const buttons = [...form.querySelectorAll('.product-card-actions button')];
    const message = form.querySelector('[data-card-message]');
    form.addEventListener('submit', async event => {
      if (!config.cartAdd || !window.fetch) return;
      event.preventDefault();
      if (!form.reportValidity() || buttons.some(button => button.disabled)) return;
      const shopNow = event.submitter?.matches('[data-shop-now]') || false;
      buttons.forEach(button => { button.disabled = true; button.setAttribute('aria-busy','true'); });
      if (message) message.textContent = '';
      try { await addToCart(form, message, shopNow); }
      catch (error) { if (message) message.textContent = error.message || config.error; }
      finally { buttons.forEach(button => { button.disabled = false; button.removeAttribute('aria-busy'); }); }
    });
  }
  function initQuickAdd(card) {
    if (card.dataset.quickAddInitialized) return;
    card.dataset.quickAddInitialized = 'true';
    const trigger = card.querySelector('[data-quick-add-open]');
    const dialog = card.querySelector('[data-quick-add-dialog]');
    const form = card.querySelector('[data-quick-add-form]');
    const close = card.querySelector('[data-quick-add-close]');
    const confirm = card.querySelector('.quick-add-confirm');
    const message = card.querySelector('[data-quick-add-message]');
    if (!trigger || !dialog || !form || !confirm) return;
    trigger.addEventListener('click', event => {
      if (trigger.getAttribute('aria-disabled') === 'true') { event.preventDefault(); return; }
      if (!config.cartAdd || !window.fetch || typeof dialog.showModal !== 'function') return;
      event.preventDefault();
      if (form.querySelector('select[name="id"]')) { dialog.showModal(); form.querySelector('select').focus(); }
      else form.requestSubmit(confirm);
    });
    trigger.addEventListener('keydown', event => { if (event.key === ' ') { event.preventDefault(); trigger.click(); } });
    close?.addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
    dialog.addEventListener('close', () => trigger.focus());
    form.addEventListener('submit', async event => {
      if (!config.cartAdd || !window.fetch) return;
      event.preventDefault();
      if (!form.reportValidity() || confirm.disabled) return;
      confirm.disabled = true;
      confirm.setAttribute('aria-busy','true');
      if (message) message.textContent = '';
      try { await addToCart(form, message, false); if (dialog.open) dialog.close(); }
      catch (error) { if (!dialog.open && typeof dialog.showModal === 'function') dialog.showModal(); if (message) message.textContent = error.message || config.error; }
      finally { confirm.disabled = false; confirm.removeAttribute('aria-busy'); }
    });
  }
  function initHero(root) {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const slides = [...root.querySelectorAll('[data-slide-panel]')];
    const landingSlideIndex = slides.findIndex(slide => slide.classList.contains('hero-slide-landing'));
    const videoSlideIndex = slides.findIndex(slide => slide.classList.contains('hero-slide-video'));
    const designSlideIndex = slides.findIndex(slide => slide.classList.contains('hero-slide-design'));
    const landingVideo = root.querySelector('.hero-slide-landing video');
    if (landingVideo) landingVideo.playbackRate = Number(root.dataset.videoSpeed) || 2;
    const colourEdit = root.querySelector('[data-colour-edit]');
    const colourItems = [...(colourEdit?.querySelectorAll('[data-colour-item]') || [])];
    const colourBackdrops = [...(colourEdit?.querySelectorAll('[data-colour-backdrop]') || [])];
    let colourIndex = 0, requestedColour = null;
    function showColour(index) {
      if (!colourEdit || !colourItems.length) return;
      const next = (index + colourItems.length) % colourItems.length;
      const incoming = colourItems[next];
      colourEdit.classList.remove('is-running', 'is-exiting');
      requestedColour = null;
      colourItems.forEach((item, i) => item.classList.toggle('is-current', i === next));
      colourBackdrops.forEach((backdrop, i) => backdrop.classList.toggle('is-current', i === next));
      incoming.classList.add('is-current');
      colourIndex = next;
      colourEdit.dataset.colourActive = String(next);
      const data = incoming.dataset;
      colourEdit.dataset.theme = data.theme || 'light';
      colourEdit.style.setProperty('--ce-background', data.background);
      colourEdit.style.setProperty('--ce-accent', data.accent);
      colourEdit.style.setProperty('--ce-swatch', data.swatch || data.accent);
      const values = {'heading-one':data.headingOne,description:data.description,note:data.note,title:data.title,summary:data.summary,shade:data.shade,shape:data.shape,hardware:data.hardware};
      Object.entries(values).forEach(([key,value]) => { const target = colourEdit.querySelector(`[data-colour-${key}]`); if (target) target.textContent = value || ''; });
      const secondLine = colourEdit.querySelector('[data-colour-heading-two]');
      if (secondLine) {
        const text = data.headingTwo || '';
        const emphasis = data.headingEmphasis || '';
        secondLine.textContent = emphasis && text.endsWith(emphasis) ? text.slice(0, -emphasis.length) : text;
        if (emphasis && text.endsWith(emphasis)) {
          const italic = document.createElement('em');
          italic.textContent = emphasis;
          secondLine.append(italic);
        }
      }
      const primaryLabel = colourEdit.querySelector('[data-colour-primary-label]');
      if (primaryLabel) primaryLabel.textContent = `${colourEdit.dataset.colourButtonPrefix || 'Meet'} ${data.title || ''}`.trim();
      colourEdit.querySelectorAll('[data-colour-link]').forEach(link => { link.href = data.link; });
      colourEdit.querySelectorAll('[data-colour-to]').forEach(button => {const active = Number(button.dataset.colourTo) === next; button.classList.toggle('is-current',active); button.setAttribute('aria-pressed',String(active));});
      const status = colourEdit.querySelector('[data-colour-status]');
      if (status) status.textContent = `${data.title}, ${data.shade}`;
      if (!reduced.matches && !paused && visible && !document.hidden && current === landingSlideIndex) { void colourEdit.offsetWidth; colourEdit.classList.add('is-running'); }
      syncColourMotion();
    }
    function syncColourMotion() {
      if (!colourEdit) return;
      const stop = current !== landingSlideIndex || !visible || paused || document.hidden || reduced.matches;
      colourEdit.dataset.paused = String(stop);
      if (!stop && !colourEdit.classList.contains('is-running')) colourEdit.classList.add('is-running');
    }
    function selectColour(index) {
      if (!colourEdit || !colourItems.length) return;
      const next = (index + colourItems.length) % colourItems.length;
      if (next === colourIndex) return;
      if (paused || reduced.matches || colourEdit.dataset.paused === 'true') showColour(next);
      else { requestedColour = next; colourEdit.classList.add('is-exiting'); }
    }
    colourEdit?.addEventListener('animationend', event => {
      if (event.target !== colourItems[colourIndex]) return;
      if (event.animationName === 'veeram-reference-bag-cycle' && requestedColour === null) showColour(colourIndex + 1);
      if (event.animationName === 'veeram-reference-bag-exit') showColour(requestedColour ?? colourIndex + 1);
    });
    colourEdit?.querySelectorAll('[data-colour-step]').forEach(button => button.addEventListener('click', () => selectColour(colourIndex + Number(button.dataset.colourStep))));
    colourEdit?.querySelectorAll('[data-colour-to]').forEach(button => button.addEventListener('click', () => selectColour(Number(button.dataset.colourTo))));
    const video = root.querySelector('.hero-slide-video video');
    const filmMedia = root.querySelector('.hero-video-media');
    const filmScenes = [...root.querySelectorAll('[data-film-scene]')];
    if (video) video.playbackRate = Number(root.dataset.videoSpeed) || 1.5;
    const pauseButton = root.querySelector('[data-motion]');
    let current = 0, timer, paused = reduced.matches, visible = true;
    const clear = () => { window.clearTimeout(timer); timer = undefined; };
    function updateFilmScene() {
      const time = video?.currentTime || 0;
      const active = filmScenes.find(scene => time >= Number(scene.dataset.sceneStart) && time < Number(scene.dataset.sceneEnd));
      filmScenes.forEach(scene => { scene.hidden = scene !== active; });
    }
    function schedule() {
      clear();
      if (root.isConnected && visible && !paused && !document.hidden && !root.contains(document.activeElement)) {
        if (current === designSlideIndex) timer = window.setTimeout(() => show(0), Number(root.dataset.duration) || 10000);
      }
    }
    function show(index, focusChange = false) {
      clear();
      current = (index + slides.length) % slides.length;
      root.classList.toggle('is-design', current === designSlideIndex);
      root.classList.toggle('is-landing', current === landingSlideIndex);
      const count = root.querySelector('#hero-slide-count');
      if (count) count.textContent = String(current + 1).padStart(2,'0');
      if (focusChange && slides.some((slide, i) => i !== current && slide.contains(document.activeElement))) root.querySelector(`[data-slide-to="${current}"]`)?.focus();
      slides.forEach((slide, i) => {
        slide.classList.toggle('is-active', i === current);
        slide.setAttribute('aria-hidden', String(i !== current));
        slide.inert = i !== current;
      });
      root.querySelectorAll('[data-slide-to]').forEach(button => {
        const active = Number(button.dataset.slideTo) === current;
        button.classList.toggle('is-current', active);
        button.setAttribute('aria-pressed', String(active));
      });
      if (video) {
        if (current === videoSlideIndex && visible && !paused && !document.hidden) {
          if (video.ended) video.currentTime = 0;
          video.play().catch(() => {});
        } else video.pause();
      }
      if (landingVideo) {
        if (current === landingSlideIndex && visible && !paused && !document.hidden) landingVideo.play().catch(() => {});
        else landingVideo.pause();
      }
      syncColourMotion();
      schedule();
    }
    function updatePause() {
      root.classList.toggle('motion-paused', paused);
      pauseButton?.setAttribute('aria-label', paused ? 'Play motion' : 'Pause motion');
      pauseButton?.setAttribute('aria-pressed', String(paused));
      if (pauseButton) pauseButton.textContent = paused ? '▷' : 'Ⅱ';
      show(current);
    }
    root.querySelectorAll('[data-slide-step]').forEach(button => button.addEventListener('click', () => show(current + Number(button.dataset.slideStep), true)));
    root.querySelectorAll('[data-slide-to]').forEach(button => button.addEventListener('click', () => show(Number(button.dataset.slideTo), true)));
    pauseButton?.addEventListener('click', () => { paused = !paused; updatePause(); });
    filmMedia?.addEventListener('click', event => {
      if (event.target.closest('a')) return;
      paused = !paused;
      updatePause();
    });
    root.querySelectorAll('[data-hero-bag-link]').forEach(link => {
      let origin, dragged = false;
      link.addEventListener('pointerdown', event => { origin = {x:event.clientX,y:event.clientY}; dragged = false; });
      link.addEventListener('pointermove', event => {
        if (origin && Math.hypot(event.clientX-origin.x,event.clientY-origin.y) > 9) dragged = true;
      });
      link.addEventListener('pointercancel', () => { origin = null; dragged = true; });
      link.addEventListener('click', event => {
        event.stopPropagation();
        if (dragged) event.preventDefault();
        origin = null;
      });
    });
    video?.addEventListener('timeupdate', updateFilmScene);
    video?.addEventListener('seeked', updateFilmScene);
    video?.addEventListener('loadedmetadata', updateFilmScene);
    root.addEventListener('focusin', () => { clear(); });
    root.addEventListener('focusout', () => schedule());
    video?.addEventListener('ended', () => { if (!paused && visible) show(videoSlideIndex + 1, true); });
    video?.addEventListener('error', () => show(videoSlideIndex + 1, true));
    landingVideo?.addEventListener('error', () => show(videoSlideIndex, true));
    const onVisibility = () => { if (root.isConnected) show(current); };
    const onReduced = () => { paused = reduced.matches; updatePause(); };
    document.addEventListener('visibilitychange', onVisibility);
    reduced.addEventListener('change', onReduced);
    const onUnload = event => {
      if (!event.target.contains(root)) return;
      clear(); video?.pause(); landingVideo?.pause();
      document.removeEventListener('visibilitychange',onVisibility);
      reduced.removeEventListener('change',onReduced);
      document.removeEventListener('shopify:section:unload',onUnload);
    };
    document.addEventListener('shopify:section:unload',onUnload);
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(entries => {
        visible = entries[0].isIntersecting;
        if (!visible) { clear(); video?.pause(); landingVideo?.pause(); }
        else show(current);
      },{threshold:.1});
      observer.observe(root);
      document.addEventListener('shopify:section:unload',event => { if (event.target.contains(root)) observer.disconnect(); },{once:true});
    }
    if (reduced.matches) { video?.pause(); landingVideo?.pause(); }
    updateFilmScene();
    updatePause();
  }
  function initFaq(root) {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const extra = root.querySelector('[data-faq-extra]');
    const toggle = root.querySelector('[data-faq-toggle]');
    if (!extra || !toggle) return;
    let transition;
    function setExpanded(expanded, animate = true) {
      transition?.cancel();
      const label = toggle.querySelector('[data-faq-toggle-label]');
      if (!expanded && extra.contains(document.activeElement)) toggle.focus();
      toggle.setAttribute('aria-expanded', String(expanded));
      label.textContent = expanded ? 'Show less' : 'Show more FAQs';
      if (expanded) extra.hidden = false;
      if (!animate || reduced.matches || !extra.animate) {
        extra.hidden = !expanded;
        return;
      }
      const height = extra.scrollHeight;
      transition = extra.animate(
        [{height: expanded ? '0px' : `${height}px`, opacity: expanded ? 0 : 1},
         {height: expanded ? `${height}px` : '0px', opacity: expanded ? 1 : 0}],
        {duration: 280, easing: 'ease-in-out'}
      );
      transition.onfinish = () => { extra.hidden = !expanded; transition = null; };
    }
    toggle.addEventListener('click', () => setExpanded(toggle.getAttribute('aria-expanded') !== 'true'));
    root.addEventListener('shopify:block:select', event => {
      if ([...extra.querySelectorAll('[data-faq-block]')].some(block => block.dataset.faqBlock === event.detail?.blockId)) setExpanded(true, false);
    });
  }
  function initProduct(root) {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const form = root.querySelector('.product-form');
    const select = root.querySelector('[data-variant-select]');
    const variants = JSON.parse(root.querySelector('[data-product-variants]')?.textContent || '[]');
    const price = root.querySelector('[data-product-price]');
    const compare = root.querySelector('[data-compare-price]');
    const submit = root.querySelector('.add-to-cart');
    const shopNow = root.querySelector('.shop-now');
    const message = root.querySelector('[data-product-message]');
    const image = root.querySelector('.product-main-image img');
    const imageStage = root.querySelector('.product-main-image');
    const quantity = root.querySelector('[data-quantity]');
    const availability = root.querySelector('[data-product-availability]');
    const colourChoices = [...root.querySelectorAll('[data-colour-choice]')];
    const thumbnails = [...root.querySelectorAll('[data-product-image]')];
    function updateImage(src, alt) {
      if (!image || !src) return;
      image.src = src;
      image.removeAttribute('srcset');
      image.alt = alt || '';
    }
    function updateVariant() {
      const variant = variants.find(v => String(v.id) === select.value);
      if (!variant) { if (submit) submit.disabled = true; if (shopNow) shopNow.disabled = true; return; }
      if (price) price.textContent = variant.price;
      if (compare) { compare.textContent = variant.compare; compare.hidden = !variant.onSale; }
      if (availability) availability.textContent = variant.available ? 'Available now' : config.sold;
      submit.disabled = !variant.available;
      if (shopNow) shopNow.disabled = !variant.available;
      root.querySelector('[data-add-text]').textContent = variant.available ? (submit.dataset.addLabel || config.add) : config.sold;
      if (message) message.textContent = '';
      updateImage(variant.image, variant.alt);
      thumbnails.forEach(button => button.setAttribute('aria-current', String(button.dataset.variantId === String(variant.id))));
      colourChoices.forEach(choice => {
        const index = Number(choice.dataset.optionPosition) - 1;
        const active = variant.options?.[index]?.toLowerCase() === choice.dataset.optionValue.toLowerCase();
        choice.setAttribute('aria-pressed', String(active));
        if (active) {
          const selected = choice.closest('fieldset')?.querySelector('[data-selected-colour]');
          if (selected) selected.textContent = choice.textContent.trim();
        }
      });
      if (quantity) {
        quantity.min = variant.min || 1;
        quantity.step = variant.step || 1;
        if (variant.max != null) quantity.max = variant.max; else quantity.removeAttribute('max');
        quantity.value = variant.min || 1;
      }
      const url = new URL(window.location.href);
      url.searchParams.set('variant',variant.id);
      window.history.replaceState({},'',url);
    }
    select?.addEventListener('change', updateVariant);
    colourChoices.forEach(choice => choice.addEventListener('click', () => {
      const index = Number(choice.dataset.optionPosition) - 1;
      const match = variants.find(v => v.available && v.options?.[index]?.toLowerCase() === choice.dataset.optionValue.toLowerCase()) || variants.find(v => v.options?.[index]?.toLowerCase() === choice.dataset.optionValue.toLowerCase());
      if (match && select) { select.value = String(match.id); select.dispatchEvent(new Event('change', {bubbles:true})); }
    }));
    function showThumbnail(button) {
      if (button.dataset.variantId && select) {
        select.value = button.dataset.variantId;
        select.dispatchEvent(new Event('change', {bubbles:true}));
      } else {
        updateImage(button.dataset.productImage, button.dataset.imageAlt);
        thumbnails.forEach(item => item.setAttribute('aria-current', String(item === button)));
      }
      button.scrollIntoView?.({block:'nearest',inline:'nearest'});
    }
    thumbnails.forEach(button => button.addEventListener('click', () => showThumbnail(button)));
    if (imageStage && thumbnails.length > 1) {
      if (image) image.draggable = false;
      imageStage.tabIndex = 0;
      imageStage.setAttribute('role', 'button');
      imageStage.setAttribute('aria-label', 'Product photos. Scroll, swipe, or use arrow keys to view more colours and photos.');
      const moveGallery = direction => {
        const current = Math.max(0, thumbnails.findIndex(button => button.getAttribute('aria-current') === 'true'));
        showThumbnail(thumbnails[(current + direction + thumbnails.length) % thumbnails.length]);
      };
      let lastWheel = 0;
      imageStage.addEventListener('wheel', event => {
        const delta = Math.abs(event.deltaY) >= Math.abs(event.deltaX) ? event.deltaY : event.deltaX;
        if (Math.abs(delta) < 8) return;
        event.preventDefault();
        if (Date.now() - lastWheel < 360) return;
        lastWheel = Date.now();
        moveGallery(delta > 0 ? 1 : -1);
      }, {passive:false});
      let pointerStart = null;
      let suppressClick = false;
      imageStage.addEventListener('dragstart', event => event.preventDefault());
      imageStage.addEventListener('pointerdown', event => {
        if (event.button !== 0) return;
        pointerStart = {x:event.clientX,y:event.clientY};
        imageStage.setPointerCapture?.(event.pointerId);
      });
      imageStage.addEventListener('pointerup', event => {
        if (!pointerStart) return;
        const dx = event.clientX - pointerStart.x;
        const dy = event.clientY - pointerStart.y;
        pointerStart = null;
        if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy) * 1.2) return;
        suppressClick = true;
        window.setTimeout(() => { suppressClick = false; }, 300);
        moveGallery(dx < 0 ? 1 : -1);
      });
      imageStage.addEventListener('pointercancel', () => { pointerStart = null; });
      imageStage.addEventListener('click', () => {
        if (suppressClick) { suppressClick = false; return; }
        moveGallery(1);
      });
      imageStage.addEventListener('keydown', event => {
        if (!['ArrowLeft','ArrowRight','Enter',' '].includes(event.key)) return;
        event.preventDefault();
        moveGallery(event.key === 'ArrowLeft' ? -1 : 1);
      });
    }
    root.querySelectorAll('[data-quantity-step]').forEach(button => button.addEventListener('click', () => {
      if (!quantity) return;
      const direction = Number(button.dataset.quantityStep);
      const minimum = Number(quantity.min) || 1;
      const increment = Number(quantity.step) || 1;
      const maximum = quantity.max ? Number(quantity.max) : Infinity;
      quantity.value = String(Math.min(maximum, Math.max(minimum, (Number(quantity.value) || minimum) + direction * increment)));
      quantity.dispatchEvent(new Event('change', {bubbles:true}));
    }));
    root.classList.add('is-enhanced');
    if (select) updateVariant();
    form?.addEventListener('submit', async event => {
      if (!config.cartAdd || !window.fetch) return;
      event.preventDefault();
      if (!form.reportValidity() || submit.disabled || shopNow?.disabled) return;
      const directCheckout = event.submitter?.matches('[data-shop-now]') || false;
      submit.disabled = true;
      if (shopNow) shopNow.disabled = true;
      submit.setAttribute('aria-busy','true');
      shopNow?.setAttribute('aria-busy','true');
      message.textContent = '';
      try {
        await addToCart(form, message, directCheckout);
      } catch (error) { message.textContent = error.message || config.error; }
      finally {
        submit.removeAttribute('aria-busy');
        shopNow?.removeAttribute('aria-busy');
        const current = variants.find(v => String(v.id) === select.value);
        submit.disabled = !current?.available;
        if (shopNow) shopNow.disabled = !current?.available;
      }
    });
  }
  function initColourCompare(root) {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const range = root.querySelector('.pastrio-split-range');
    if (!range) return;
    const hitbox = root.querySelector('[data-compare-hitbox]') || root;
    const update = value => {
      const position = Math.max(0, Math.min(100, Number(value)));
      range.value = String(position);
      root.style.setProperty('--split-position', `${position}%`);
      range.setAttribute('aria-valuetext', `${position} percent ${range.dataset.mintLabel}, ${100 - position} percent ${range.dataset.lavenderLabel}`);
    };
    const updateFromPointer = event => {
      const bounds = hitbox.getBoundingClientRect();
      if (bounds.width) update(Math.round((event.clientX - bounds.left) / bounds.width * 100));
    };
    let dragging = false, dragOrigin = null, moved = false;
    hitbox.addEventListener('dragstart', event => event.preventDefault());
    hitbox.addEventListener('pointerdown', event => {
      if (event.button !== 0 && event.pointerType === 'mouse') return;
      if (hitbox !== root) event.preventDefault();
      dragging = true;
      moved = false;
      dragOrigin = {x:event.clientX,y:event.clientY};
      hitbox.setPointerCapture?.(event.pointerId);
      updateFromPointer(event);
      if (hitbox === root) range.focus({preventScroll:true});
    });
    hitbox.addEventListener('pointermove', event => { if (dragging) {if (dragOrigin && Math.hypot(event.clientX-dragOrigin.x,event.clientY-dragOrigin.y) > 6) moved = true; updateFromPointer(event);} });
    const stop = event => {
      dragging = false;
      if (hitbox.hasPointerCapture?.(event.pointerId)) hitbox.releasePointerCapture(event.pointerId);
    };
    hitbox.addEventListener('pointerup', stop);
    hitbox.addEventListener('pointercancel', stop);
    if (hitbox !== root) root.addEventListener('click', event => { if (moved && event.target.closest('.product-card-link')) {event.preventDefault(); moved = false;} }, true);
    range.addEventListener('input', () => update(range.value));
    update(range.value);
  }
  function init(scope = document) {
    scope.querySelectorAll('[data-card-gallery]').forEach(data => {
      const card = data.closest('.product-card');
      if (!card) return;
      if (card.dataset.galleryReady) return;
      card.dataset.galleryReady = 'true';
      const stage = card.querySelector('.product-image');
      const picture = stage?.querySelector('img');
      if (!stage || !picture || !data) return;
      let images;
      try { images = JSON.parse(data.textContent).filter(Boolean); } catch { return; }
      if (images.length < 2) return;
      let index = images.findIndex(url => picture.currentSrc === url || picture.src === url);
      let start = null, swiped = false;
      stage.addEventListener('pointerdown', event => { if (event.pointerType !== 'mouse') start = {x:event.clientX,y:event.clientY}; });
      stage.addEventListener('pointerup', event => {
        if (!start) return;
        const delta = event.clientX - start.x;
        const vertical = Math.abs(event.clientY - start.y);
        start = null;
        if (Math.abs(delta) < 30 || Math.abs(delta) < vertical) return;
        index = (index + (delta < 0 ? 1 : -1) + images.length) % images.length;
        picture.removeAttribute('srcset');
        picture.src = images[index];
        swiped = true;
      });
      stage.addEventListener('pointercancel', () => { start = null; });
      stage.addEventListener('click', event => { if (swiped) { event.preventDefault(); swiped = false; } }, true);
    });
    scope.querySelectorAll('[data-cart-step]').forEach(button => {
      if (button.dataset.initialized) return;
      button.dataset.initialized = 'true';
      button.addEventListener('click', () => {
        const form = button.closest('form');
        const quantity = document.getElementById(button.dataset.cartTarget);
        if (!form || !quantity) return;
        const next = Math.max(0, Math.min(quantity.max ? Number(quantity.max) : Infinity, (Number(quantity.value) || 0) + Number(button.dataset.cartStep) * (Number(quantity.step) || 1)));
        if (next === Number(quantity.value)) return;
        quantity.value = String(next);
        form.requestSubmit(form.querySelector('[data-cart-update]'));
      });
    });
    scope.querySelectorAll('[data-hero]').forEach(initHero);
    scope.querySelectorAll('[data-faq]').forEach(initFaq);
    scope.querySelectorAll('[data-product-section]').forEach(initProduct);
    scope.querySelectorAll('[data-card-purchase]').forEach(initCardPurchase);
    scope.querySelectorAll('.product-card--quick').forEach(initQuickAdd);
    scope.querySelectorAll('[data-colour-compare]').forEach(initColourCompare);
    scope.querySelectorAll('.mobile-menu nav a').forEach(link => link.addEventListener('click', () => { const menu = link.closest('.mobile-menu'); if (menu) menu.open = false; }));
  }
  init();
  document.addEventListener('shopify:section:load',event => init(event.target));
  document.addEventListener('veeram:cards:updated',event => event.target.querySelectorAll('[data-card-purchase]').forEach(initCardPurchase));
  document.addEventListener('keydown',event => {
    if (event.key === 'Escape') document.querySelectorAll('.mobile-menu[open]').forEach(menu => { menu.open = false; menu.querySelector('summary').focus(); });
  });
})();
